<template>
  <div class="list-pagination d-flex justify-content-end">
    <vue-awesome-paginate
      :total-items="totalItems"
      v-model="currentPage"
      :items-per-page="itemsPerPage"
    >
      <template #prev-button>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          >
            <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
          </svg>
        </span>
      </template>
      <template #next-button>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="white"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          >
            <path d="M8.122 24l-4.122-4 8-8-8-8 4.122-4 11.878 12z" />
          </svg>
        </span>
      </template>
    </vue-awesome-paginate>
  </div>
</template>

<script>
import { computed, ref } from "vue";
export default {
  props: ["modelValue", "totalItems", "itemsPerPage"],
  setup(props, { emit }) {
    const currentPage = computed({
      get: () => {
        if (props.modelValue) {
          return props.modelValue;
        } else {
          return "";
        }
      },
      set: (value) => {
        emit("update:modelValue", value);
      },
    });

    return {
      currentPage,
    };
  },
};
</script>

<style>
.list-pagination .pagination-container {
  column-gap: 10px;
  align-items: center;
}
.list-pagination .paginate-buttons {
  height: 35px;
  width: 35px;
  cursor: pointer;
  border-radius: 4px;
  background-color: transparent;
  border: none;
  color: black;
}

.list-pagination .back-button,
.list-pagination .next-button {
  background-color: black;
  color: white;
  border-radius: 8px;
  height: 45px;
  width: 45px;
}
.list-pagination .active-page {
  background-color: #e5e5e5;
}
.list-pagination .paginate-buttons:hover {
  background-color: #f5f5f5;
}
.list-pagination .active-page:hover {
  background-color: #e5e5e5;
}

.list-pagination .back-button svg {
  transform: rotate(180deg) translateY(-2px);
}
.list-pagination .next-button svg {
  transform: translateY(2px);
}

.list-pagination .back-button:hover,
.list-pagination .next-button:hover {
  background-color: rgb(45, 45, 45);
}

.list-pagination .back-button:active,
.list-pagination .next-button:active {
  background-color: rgb(85, 85, 85);
}
</style>
